import { createAsyncThunk } from "@reduxjs/toolkit";
import * as APICalls from "../../../utils/APICalls/APICalls";

export const getRestaurantSocialMedia = createAsyncThunk(
  "fetchRestaurantSocialMedia",
  async (restaurantId: number) => {
    const referralCode = await APICalls.getRestaurantSocialMediaByRestaurantId(
      restaurantId
    );

    return referralCode.data;
  }
);
